import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

interface ContentCardProps {
  readonly title?: string;
  readonly description?: ReactNode;
  /** 제목 줄 오른쪽 동작. */
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly className?: string;
  /** 섹션 id — 주소 해시(#id)로 이 카드에 바로 가게 할 때. */
  readonly id?: string;
  /** 섹션의 접근성 이름 — 제목이 없거나 제목과 다른 이름으로 읽혀야 할 때. */
  readonly 'aria-label'?: string;
}

/** 연회색 본문 바탕 위의 흰 카드 — 섹션 묶음(제목 h2·설명·동작)과 표를 담는다. */
export const ContentCard = ({
  title,
  description,
  actions,
  children,
  className,
  id,
  'aria-label': ariaLabel,
}: ContentCardProps): ReactElement => (
  <section
    id={id}
    aria-label={ariaLabel}
    className={cn(
      'rounded-2xl border border-foreground/[0.06] bg-card p-6 shadow-[0_1px_2px_rgba(0,0,0,0.03)]',
      className,
    )}
  >
    {title ? (
      <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="text-lg font-semibold tracking-[-0.01em]">{title}</h2>
          {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    ) : null}
    {children}
  </section>
);
